const warrantyHandleMap = new Map([
  ["utility-linear-actuators", true],
  ["heavy-duty-track-actuator", true],
  ["adjustable-stroke-linear-actuators", true],
  ["linear-actuators", true],
  ["heavy-duty", true],
  ["premium-linear-actuators", true],
  ["premium-high-force-linear-actuators",true],
  ["feedback-rod-actuator", true],
  ["deluxe-rod-actuator", true],
  ["industrial-heavy-duty-linear-actuators", true],
  ["high-speed-actuator", true],
  ["mini-track-actuator", true],
  ["optical-sensor-actuators", true],
  ["tubular-linear-actuator", true],
  ["mini-linear-actuator", true],
  ["bullet-series-mini-actuators", true],
  ["bullet-series-50-cal-linear-actuators", true],
  ["heavy-duty-linear-actuator-ip66", true],
  ["electric-column-lift", true],
  ["bullet-series-36-cal-linear-actuators", true],
  ["bullet-series-23-cal", true],
  ["bullet-series-35-cal-linear-actuators", true],
  ["micro-pen-actuators-12v", true],
  ["silent-micro-linear-actuator", true],
  ["f12-micro-linear-actuators", true],
  ["micro-actuators", true],
  ["micro-actuators-12v", true],
  ["potentiometer", true],
  ["pop-up-tv-lift", true],
  ["39-pop-up-tv-lift", true],
  ["drop-down-tv-lift", true],
  ["motorized-flip-down-tv-ceiling-mount", true],
  ["outdoor-tv-lift-cabinet", true],
  ["sit-stand-desk", true],
  ["motorized-desk-lift", true],
  ["electric-table-lift", true],
  ["sit-stand-desk-lift", true],
  ["treadmill-desk", true],
  ["two-channel-remote-control-system", true],
  ["four-channel-remote-control-system", true],
  ["synchronous-control-board", true]

  



  
]);